import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { actionCreators } from './store.js';
import Profile from './Profile.js';

class ProfileContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tab: null };
  }

  componentDidMount = () => {
    const { match } = this.props;
    let matchSplit = match.url.split('/');
    let tab = matchSplit.length === 4 ? matchSplit[3] : '';
    this.setState({ tab: tab });
    this.loadCustomerDetails(match.params.adfitNo);
  };

  loadCustomerDetails = (adfitNo) => {
    const { getAccountDetails } = this.props;
    if (this.shouldReloadData()) {
      //reload only on different adfit no
      getAccountDetails(adfitNo);
    }
  };
  shouldReloadData = () => {
    //only reload if adfitNo from query string differs from the one in store
    const { match, profile } = this.props; //query string
    return profile.adfitNo !== match.params.adfitNo;
  };

  render = () => {
    const { localisation, profile } = this.props;

    const shouldReloadData = this.shouldReloadData();
    return (
      <Profile
        profileDetails={shouldReloadData ? {} : profile}
        localisation={localisation}
      />
    );
  };
}

ProfileContainer.propTypes = {
  profileDetails: PropTypes.object,
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      profile: state.profile,
      localisation: state.localisation,
    }),
    {
      getAccountDetails: actionCreators.getAccountDetails,
    }
  )
)(ProfileContainer);
